import neuralNetwork from "./NeuralNetwork";
import handPose from "./HandPose";
import sentiment from "./Sentiment";
import faceMesh from "./FaceMesh";
import bodyPose from "./BodyPose";
import imageClassifier from "./ImageClassifier";
import soundClassifier from "./SoundClassifier";
import objectDetection from "./ObjectDetection";
import featureExtractor from "./FeatureExtractor";
import setBackend from "./utils/setBackend";
import configureBackend from "./utils/configureBackend";
import bodySegmentation from "./BodySegmentation";
import depthEstimation from "./DepthEstimation";
import communityStatement from "./utils/communityStatement";
import * as tf from "@tensorflow/tfjs";
import * as tfvis from "@tensorflow/tfjs-vis";
import p5Utils from "./utils/p5Utils";
import packageInfo from "../package.json";

const withPreload = {
  bodyPose,
  bodySegmentation,
  depthEstimation,
  faceMesh,
  featureExtractor,
  handPose,
  imageClassifier,
  neuralNetwork,
  sentiment,
  soundClassifier,
  objectDetection,
};

const withoutAsync = {
  neuralNetwork,
};

const ml5 = Object.assign({ p5Utils }, withPreload, {
  tf,
  tfvis,
  setBackend,
  version: packageInfo.version,
  setP5: p5Utils.setP5.bind(p5Utils),
});

p5Utils.setupP5Integration(
  ml5,
  Object.keys(withPreload),
  Object.keys(withoutAsync)
);

// Apply ml5's default TensorFlow.js backend configuration (see issue #302).
configureBackend();

communityStatement();

export default ml5;